"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTeamQuerySchema = exports.ListTeamsQuerySchema = exports.UpdateTeamBodySchema = exports.CreateTeamBodySchema = exports.ListTeamsResponseSchema = exports.UpdateTeamResponseSchema = exports.CreateTeamResponseSchema = exports.GetTeamResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
/**
 * Responses
 */
exports.GetTeamResponseSchema = common_1.TeamSchema;
exports.CreateTeamResponseSchema = common_1.TeamSchema;
exports.UpdateTeamResponseSchema = common_1.TeamSchema;
exports.ListTeamsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.GetTeamResponseSchema);
/**
 * Body
 */
exports.CreateTeamBodySchema = (0, core_1.StrictObject)({
    name: core_1.NameSchema,
    description: core_1.DescriptionSchema,
    tierId: core_1.IdSchema,
    currency: core_1.CurrencySchema,
    status: ruby_1.TeamStatusSchema,
    isAgencyAccount: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    clientType: typebox_1.Type.Optional(ruby_1.ClientTypeSchema),
});
exports.UpdateTeamBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.Optional(core_1.NameSchema),
    description: typebox_1.Type.Optional(core_1.DescriptionSchema),
    tierId: typebox_1.Type.Optional(core_1.IdSchema),
    status: typebox_1.Type.Optional(ruby_1.TeamStatusSchema),
    isAgencyAccount: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    clientType: typebox_1.Type.Optional(ruby_1.ClientTypeSchema),
});
/**
 * Parameters
 */
exports.ListTeamsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.GetTeamQuerySchema = typebox_1.Type.Object({
    includeDeleted: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
